import CommonService from '../commonService';

const CUSTOMER_DATA_PATH = 'bff-customer-data';
const CUSTOMER_DATA_ENDPOINT = 'read';

const CustomerDataService = new CommonService(CUSTOMER_DATA_PATH, CUSTOMER_DATA_ENDPOINT);
export default CustomerDataService;
